import styled from 'styled-components';
import Color from 'constants/color';
import { Card } from 'antd';
import { Link } from 'react-router-dom';

export const TextHeader = styled.p`
  color: ${Color.ocean};
  font-size: 42px;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 2px 3px 6px rgba(20, 85, 123, 0.3);
`;

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: grid;
  background: linear-gradient(135deg, ${Color.primaryNew}, ${Color.accent});

  .animation-loop {
    animation: bounce 4s infinite;
  }

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
      opacity: 1;
    }
    40% {
      transform: translateY(-30px);
      opacity: 0.8;
    }
    60% {
      transform: translateY(-15px);
      opacity: 0.5;
    }
  }

  .animation-spin {
    animation-name: spin;
    animation-duration: 10000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  /* grid-template-columns:2.5fr 4fr; */

  .content-wallpaper {
    display: inline;
    align-content: center;
    /* position:relative; */
    justify-content: center;
    overflow: hidden;

    .content-center {
      display: flex;
      margin: auto;
      width: 100%;
      height: 100%;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
    }
    /* background-image: linear-gradient(180deg, ${Color.blue}, ${Color.primary}); */
    .background {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .ellipse {
      position: absolute;
      width: 521px;
      height: 521px;
      left: -135px;
      bottom: 0;
    }
    .ellipse2 {
      position: absolute;
      width: 474px;
      height: 474px;
      left: 00px;
      bottom: -52px;
    }

    span {
      top: 15%;
      position: absolute;
      color: ${Color.white};
      font-size: 100px;
      font-weight: 300;
      white-space: nowrap;
      text-shadow: 7px 15px 12px ${Color.darkGray};
    }
    p {
      /* top:15%; */
      position: relative;
      color: ${Color.white};
      font-size: 100px;
      font-weight: 500;
      text-align: center;
      justify-content: center;
      text-shadow: 7px 15px 12px ${Color.darkGray};
    }
  }

  .main-login-content {
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-image: url('../../../assets/image/background/loginBackground.png'); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    z-index: 1;

    .max-content {
      transition: 0.8s;
      /* background: ${Color.white}; */
      width: 100%;
      max-width: 550px;
      padding: 30px;
      max-height: 900px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 10px;
      position: relative;
      z-index: 2;
      box-shadow: rgba(123, 255, 155, 1.25) 0px 0px 15px;
      border: 1px solid ${Color.accent};
      border-radius: 25px;
      /* box-shadow: 0px 1px 20px rgba(102, 112, 133, 0.25); */
      img {
        margin: 0px 0px 0px 0px;
      }
      .box-center {
        transition: 0.8s;
        margin-top: 12px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        .title-login {
          font-family: Poppins;
          font-weight: 700;
          font-size: 26px;
          color: ${Color.black};
        }

        .titie-description {
          font-weight: 400;
          font-size: 18px;
          color: ${Color.primary};
        }

        .icon-prefix {
          margin-right: 8px;
          color: ${Color.primary};
        }
      }
      .box {
        transition: 0.8s;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: grid;
        gap: 32px;

        .line {
          height: 1px;
          width: 70px;
          background: ${Color.primary} !important;
        }

        .title-login {
          font-weight: 700;
          font-size: 24px;
          color: ${Color.black};
        }

        .titie-description {
          font-weight: 400;
          font-size: 18px;
          color: ${Color.primary};
        }

        .icon-prefix {
          margin-right: 8px;
          color: ${Color.primary};
        }

        .fade-in {
          animation: fadeIn 5s;
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }

      .box-rending {
        overflow: hidden;
        transition: 0.8s;
        height: 100%;

        .line {
          height: 1px;
          width: 70px;
          background: ${Color.primary} !important;
        }

        .fade-in {
          animation: fadeIn 5s;
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
  }

  .line {
    height: 1px;
    width: 70px;
    background: ${Color.gray};
  }

  .cpf-btn {
    width: 100%;
    background: ${Color.primary} !important;
    border-color: ${Color.primary} !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    img {
      margin: 0px 8px 0px 0px !important;
    }
    span {
      letter-spacing: 1px !important;
    }
  }

  .local-btn {
    margin-top: 24px;
    width: 100%;
    /* background:#FFF !important; */
    /* .title-btn{ */
    /* color:${Color.primary}; */
    /* } */
  }
  .login-btn {
    width: 100%;
    span {
      letter-spacing: 1px !important;
    }
  }

  .box-rending {
    overflow: hidden;
    transition: 0.8s;
    height: 0px;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: ${Color.gray} !important;
    border: 1px solid ${Color.gray} !important;
  }
  .ant-input:focus {
    box-shadow: unset !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: unset !important;
    border-color: ${Color.gray} !important;
  }

  @media only screen and (max-width: 1350px) {
    .content-wallpaper {
      span {
        font-size: 75px;
      }
    }
  }
  @media only screen and (max-width: 990px) {
    .content-wallpaper {
      span {
        font-size: 60px;
      }
    }
  }

  @media only screen and (max-width: 755px) {
    grid-template-columns: 1fr;
    .content-wallpaper {
      display: none;
    }
    .main-login-content {
      padding: 0px 12px 0px 12px;
    }
  }
`;

export const AnimationSlider = styled.div`
  width: 100%;

  .login-ad-active {
    min-height: fit-content !important;
    opacity: 1;
    transition: 450ms ease-in-out;
  }
  .login-ad-inactive {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    transition: 450ms ease-in-out;
  }
  .login-cpex-active {
    height: 335px;
    opacity: 1;
    transition: 450ms ease-in-out;
  }
  .login-cpex-inactive {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    transition: 450ms ease-in-out;
  }
  .postion-ro-style {
    text-align: -webkit-center;
  }
  .or-style {
    display: grid;
    grid-template-columns: 3fr 1fr 3fr;
    margin-top: 24px;
    margin-bottom: 24px;
    width: 50%;
    align-items: baseline;
    .line-or {
      display: flex;
      height: 1px;
      width: 100%;
      background-color: ${Color.primary};
    }
    p {
      text-align: center;
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      color: ${Color.primary};
    }
  }
`;

export const LoginAdContent = styled.div`
  width: 100%;
  margin-bottom: 16px;
  button {
    width: 100%;
  }
`;

export const LoginContent = styled.div`
  margin-top: 16px;
  .position-text-forgot {
    text-align: center;
    margin-top: 16px;
    cursor: pointer;
    p {
      text-decoration: underline;
      font-size: 14px;
      color: ${Color.darkGray2};
      font-weight: 400;
    }
  }
`;

export const TextLink = styled(Link)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: ${Color.primary};
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 24px;
  cursor: pointer;
  :hover {
    opacity: 0.8;
    color: ${Color.primary};
  }
`;

export const ImgLogo = styled.img`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 auto !important;
`;
